module.exports = __webpack_public_path__ + "assets/sketch.27f2965a.svg";